import AcceptationUserPortailModalController from './acceptation-user-portail-modal.controller';
import AcceptationUserPortailModalHtml from './acceptation-user-portail-modal.tpl.html';
export default {
	bindings: {
		resolve: '=',
		close: '&',
		dismiss: '&'
	},
	// templateUrl: 'app/common/configuration-email/components/configuration-email-form/configuration.email.form.html',
	template: AcceptationUserPortailModalHtml,
	controller: AcceptationUserPortailModalController
};
